import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { delPdtWishList, savePdtWishList } from '@app/actions/shoppingmall/wishlist-pdt.action';
import { setWAlert } from '@app/actions/w-alert.action';
import { ActionConstant } from '@app/common/constant/action-constant';
import { MessageConstant } from '@app/common/constant/message.constant';
import { MyProgramConstant } from '@app/common/constant/my-program.constant';
import { WAlertConstant } from '@app/common/constant/w-alert-icon.constant';
import { AuthUtil } from '@app/common/util/auth.util';
import { ConvertUtil } from '@app/common/util/convert.util';
import { ValidationUtil } from '@app/common/util/validation.util';
import { OrderMstModel } from '@app/models/myoffice/order/order-mst.model';
import { OrdPdtModel } from '@app/models/shoppingmall/order-pdt.model';
import { SmWownetModel } from '@app/models/system/sm-wownet.model';
import { CartState, getCartInfo } from '@app/selectors/shoppingmall/cart.selector';
import { ProductState, getReviewProducts } from '@app/selectors/shoppingmall/product.selector';
import { PdtWishListState } from '@app/selectors/shoppingmall/wishlist-pdt-selector';
import { getSmWownet, SmWownetState } from '@app/selectors/system/sm-wownet.selector';
import { WAlertState } from '@app/selectors/w-alert.selector';
import { CartService } from '@app/services/shoppingmall/cart.service';
import { Store } from '@ngrx/store';
import { ClipboardService } from 'ngx-clipboard';
import { Observable } from 'rxjs';

@Component({
  selector: 'hp-reviews',
  templateUrl: './hp-reviews.component.html',
  styleUrls: ['./hp-reviews.component.css']
})
export class HpReviewsComponent implements OnInit {
  @Input() urlWownet : string = "";

  @Output() itemProduct = new EventEmitter<OrdPdtModel>();

  products$ = new Observable<OrdPdtModel[]>();
  products: OrdPdtModel[] = [];

  cartInfo$ = new Observable<OrderMstModel[]>();
  cartInfo: OrderMstModel[] = {} as OrderMstModel[];

  quantities: number[] = [];
  wishYn: string[] = [];
  
  smWownet$ = new Observable<SmWownetModel>;
  
  urlShopping: string = "";
  
  constructor(
    private _productStore: Store<ProductState>,
    private _wAlertStore: Store<WAlertState>,
    private clipboard: ClipboardService,
    private _wishListStore: Store<PdtWishListState>,
    private _cartStore: Store<CartState>,
    private _router : Router,
    private _smWownetStateStore: Store<SmWownetState>,
    private _cartSerivce: CartService
    ) { 
    this.products$ = this._productStore.select(getReviewProducts);
    this.smWownet$ = this._smWownetStateStore.select(getSmWownet);
  }

  ngOnInit(): void {
    this.smWownet$.subscribe(res => {
      if (ValidationUtil.isNotNullAndNotEmpty(res)) {
          this.urlShopping = res.urlShopping;
      }
    });

    this._cartStore.select(getCartInfo).subscribe(res => {
      this.cartInfo = res;
    });

    this.products$.subscribe(res => {
      if(ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.products = res;

        setTimeout(() => {
          this.productChange();
        }, 500);
      }  
    });
  }

  productChange(){
    let length = this.products.length;
    this.quantities = new Array(length);
    this.wishYn = new Array(length);
    for (let i = 0; i < length; i++) {
      this.quantities[i] = 1;
      this.wishYn[i] = ConvertUtil.convertToSring(this.products[i].wishYN);
    }
  }

  handleOnClickProductDetail(item: any): void {
    this.itemProduct.emit(item);
  }

  handleOnAddToCart(index: number): void {
    if (index >= 0 && index < this.quantities.length && index < this.products.length) {
      let item = this.products[index];
      let quantity = this.quantities[index];

      if (AuthUtil.isLogined()) { 
        this._cartSerivce.addCartItemLogin(item, quantity, this.cartInfo);
      } else {
        this._cartSerivce.addCartItemNotLogin(item, quantity);
      }
    } 
  }

  handleOnclickAddWhislist(item: any, index: any):void{
    if (!AuthUtil.isLogined()) {
      this.showAlertRequiredLogined();
    } else {
      let member = AuthUtil.getLoginedInfo();
      let userid = '';
      if (member) {
        userid = ConvertUtil.convertToSring(member.userid);
      }

      if(this.wishYn[index] == 'Y'){
        this.wishYn[index] = 'N'
        this._wishListStore.dispatch(delPdtWishList({userid: userid, pdtCd: item.pdtCd}));
        this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.successful, message: "정상적으로 삭제되었습니다." } }));
      }else{
        this.wishYn[index] = 'Y'

        this._wishListStore.dispatch(savePdtWishList({userid: userid, pdtCd: item.pdtCd}));
        this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.successful, message: "정상적으로 추가되었습니다." } }));
      }
    }
  }

  showAlertRequiredLogined(): void {
    this._wAlertStore.dispatch(
      setWAlert({ 
        wAlert: { 
          icon: WAlertConstant.confirm, 
          message: MessageConstant.msgRequiredLogin, 
          action: ActionConstant.actionConfirmLogined 
        } 
    }));
  }

  handleOnClickCopyProduct(item: any) {
    if (!AuthUtil.isLogined()) {
      this.showAlertRequiredLogined();
    } else {
      let userid2='';
      if(AuthUtil.getLoginedInfo()){
        userid2 = ConvertUtil.convertToSring(AuthUtil.getLoginedInfo()?.userid2);
      }
      if(AuthUtil.getInfoUserId2()){
        userid2 = ConvertUtil.convertToSring(AuthUtil.getInfoUserId2()?.userid2);
      }

      this.clipboard.copyFromContent(this.urlShopping + MyProgramConstant.urlShopping + '/product/' + item.pdtCd+ '?userid2=' + userid2);
      this._wAlertStore.dispatch(setWAlert({ wAlert: {icon: WAlertConstant.successful, message: MessageConstant.msgCopyUrlPdt} }));
    }
  }
}
